import {
    CREATE_DISABLED_GAMES,
    CREATE_GAMES,
    ENABLE_DISABLE_GAME,
    SELECT_GAME,
    SET_GAME_CONTROLLER_STATE, SET_PROMO_BALANCE_WEB, UPDATE_ON_LOAD
} from '../constants/actionTypes';
import startWebsocket from '../startWebsocket';
import moment from 'moment';

export function createGames(gameList, startingCategory, store) {

    let selectedGameIndex = store.getState().vpp.selectedGameIndex;

    //open the default game websocket
    gameList[selectedGameIndex].ws = startWebsocket(store, gameList[selectedGameIndex].URL.WS_URL);

    let ret = {
        type: CREATE_GAMES,
        gameList
    };
    return ret;
}

export function createDisabledGames(gameList) {
    let ret = {
        type: CREATE_DISABLED_GAMES,
        gameList
    };
    return ret;
}

export function selectGame(gameIndex, store) {

    // close the previous ws
    let selectedGameIndex = store.getState().vpp.selectedGameIndex;
    let games = store.getState().vpp.games;
    let newWs;

    if (gameIndex !== store.getState().vpp.selectedGameIndex && games[selectedGameIndex].ws !== undefined) {
        games[selectedGameIndex].ws._closeWebsocket();
        newWs = startWebsocket(store, games[gameIndex].wsUrl);
    }

    let ret = {
        type: SELECT_GAME,
        gameIndex,
        newWs
    };
    return ret;
}

export function enableDisableGame(gameIndex, newGameState) {
    let ret = {
        type: ENABLE_DISABLE_GAME,
        gameIndex,
        newGameState
    };
    return ret;
}

export function setGameControllerState(gameChannel, state, isGroupedEvent, bulkUpdate, eventTimeDate) {
    return {type: SET_GAME_CONTROLLER_STATE, gameChannel, state, isGroupedEvent, bulkUpdate, eventTimeDate};
}
export function updatePromoBalanceFromWeb(promoBalances) {
    return {type: SET_PROMO_BALANCE_WEB, promoBalances};
}
export function updateLoadFunction(boolVal,store){
    return {type: UPDATE_ON_LOAD};
}


// WEBPACK FOOTER //
// ./src/actions/gamesActions.js